export default {"src":"/_next/static/media/arrow-left.dce27b71.svg","height":15,"width":9,"blurWidth":0,"blurHeight":0};